/**
 * Utils Factory
 */

(function() {

    'use strict';

    angular.module('itxApp.common')
        .service('ItxDateTimeFct', ItxDateTimeFct);

    ItxDateTimeFct.$inject = [
        'ItxTranslateSvc',
        'CountryService',
        'DUTTI_CONS'
    ];

    /**
     * Utilities shared in the app
     * @constructor
     */
    function ItxDateTimeFct(
        ItxTranslateSvc,
        CountryService,
        DUTTI_CONS
    ) {

        var format = getFormatDate();

        var dateTranslations = null;
        var dd = format.indexOf('dd'),
            mm = format.indexOf('mm'),
            y = format.indexOf('yy');

        var funcs = {
            isValidDate: isValidDate,
            toBirthDate: toBirthDate,
            toDefaultDate: toDefaultDate,
            isDateAfterToday: isDateAfterToday,
            isDateAfterYesterday: isDateAfterYesterday,
            isValidHour: isValidHour,
            isValidAge: isValidAge,
            isWithinDatetime: isWithinDatetime,
            getCalendarFormat: getCalendarFormat,
            getFormatDate: getFormatDate,
            loadDateTranslations: loadDateTranslations
        };

        return funcs;

        function getFormatDate( ) {

            if( inditex.iStoreId === DUTTI_CONS.stores.DuttiCN ) {
                    return 'yy/mm/dd';
            } else  if(  inditex.iStoreId === DUTTI_CONS.stores.DuttiAE ) {
                    return 'yy/dd/mm';

            } else if ( inditex.iStoreId === DUTTI_CONS.stores.DuttiKR ||
                inditex.iStoreId === DUTTI_CONS.stores.DuttiRU || 
                inditex.iStoreId === DUTTI_CONS.stores.DuttiUS ||
                inditex.iStoreId === DUTTI_CONS.stores.DuttiUK   ){
                return 'mm/dd/yy';
            }  else{

                return 'dd/mm/yy';
            }

        }

        /**
         * Test if date is valid (format + date)
         * @param {string} date
         * @returns {boolean}
         */

        function isValidDate(testDate, store) {

            if(!testDate) {
                return false;
            }

            // Define el pattern para comprobar que la fecha dada es correcta
            var expr;

            // Casos para tipo de fecha: "yy/dd/mm"
            if(format === 'yy/dd/mm') {

                expr = /^[1-2][0-9]{3}\/(0[1-9]|[1-2][0-9]|3[0-1])\/(0[1-9]|1[0-2])$/;
            }
            else {
                expr = /^(0[1-9]|1[0-2])\/(0[1-9]|[1-2][0-9]|3[0-1])\/[1-2][0-9]{3}$/;
            }

            // Construye la fecha dada (testDate) en base al formato especificado    
            var dateFormat;
            var storeJSON = store? store: inditex.iStoreJSON;

            // Caso para China  
            if (storeJSON.countryCode === 'CN' && y === 0) { 
                
                dateFormat = testDate.substring(mm + 2, mm + 4) + testDate.substring(mm + 4, mm + 5) + testDate.substring(dd + 2, dd + 4) + testDate.substring(y + 4, y + 5) + testDate.substring(y, y + 4);
            }
            // Casos para tipo de fecha: "yy/dd/mm"
            else if(format === 'yy/dd/mm') {
                // Año
                dateFormat = testDate.substring(y, y + 4);
                // Contrabarra
                dateFormat += testDate.substring(y + 4, y + 5);
                // Día
                dateFormat += testDate.substring(dd + 2, dd + 4);
                // Contrabarra
                dateFormat += testDate.substring(dd + 4, dd + 5);
                // Mes
                dateFormat += testDate.substring(mm + 2, mm + 4);
            } 
            else {

                dateFormat = testDate.substring(mm, mm + 2) + testDate.substring(mm + 2, mm + 3) + testDate.substring(dd, dd + 2) + testDate.substring(dd + 2, dd + 3) + testDate.substring(y, y + 4);
            }

            // Extrae cada elemento de fecha y los convierte en enteros
            var dia;
            var mes;
            var anho;

            // Casos para tipo de fecha: "yy/dd/mm"
            if(format === 'yy/dd/mm') { 

                anho = parseInt(dateFormat.substring(0, 4));
                dia = parseInt(dateFormat.substring(5, 7));
                mes = parseInt(dateFormat.substring(8, 10));                        
            }
            else {

                mes = parseInt(dateFormat.substring(0, 2));
                dia = parseInt(dateFormat.substring(3, 5));
                anho = parseInt(dateFormat.substring(6, 10));
            }

            // Comprueba que el día dado sea correcto en base al mes
            if (mes === 2) { // Años bisiestos

                if (anho % 4 === 0) {
                    if (dia > 29) {
                        return false;
                    }
                } else {
                    if (dia > 28) {
                        return false;
                    }
                }
            // Meses con 31 días
            } else if (mes === 1 || mes === 3 || mes === 5 || mes === 7 || mes === 8 || mes === 10 || mes === 12) {
                if (dia > 31) {
                    return false;
                }
            // Meses con 30 días
            } else {
                if (dia > 30) {
                    return false;
                }
            }           

            // Comprueba que la fecha tenga el número de carácteres correctos y coincida con el pattern dado
            if (testDate.length === 10 && expr.test(dateFormat)) {
                
                // En los casos para tipo de fecha: "yy/dd/mm", invertimos el orden de los componentes
                if(format === 'yy/dd/mm') {
                    dateFormat = dateFormat.split('/');
                    dateFormat = dateFormat[2] + '-' + dateFormat[1] + '-' + dateFormat[0];
                }

                // Comprueba que la fecha dada obtenga un valor correcto cuando lo convertimos a un objeto de fecha
                if (new Date(dateFormat).getDate() > 0 ) {
                    return true;
                }                               
            }

            return false;
        }


        /**
         * Converts a date to a valid birthdate date (yyyy-MM-dd)
         * @param {string} date
         * @returns {string} date formatted
         */
        function toBirthDate(srcDate,store) {
            var storeJSON = store? store: inditex.iStoreJSON;
            var dateFormat;
            if (storeJSON.countryCode === 'CN' && y === 0) {
                dateFormat = srcDate.substring(mm + 2, mm + 4) + srcDate.substring(mm + 4, mm + 5) + srcDate.substring(dd + 2, dd + 4) + srcDate.substring(y + 4, y + 5) + srcDate.substring(y, y + 4);
            } 
            // Casos para tipo de fecha: "yy/dd/mm"
            else if(format === 'yy/dd/mm') {
                // Año
                dateFormat = srcDate.substring(y, y + 4);
                // Contrabarra
                dateFormat += srcDate.substring(y + 4, y + 5);
                // Día
                dateFormat += srcDate.substring(dd + 2, dd + 4);
                // Contrabarra
                dateFormat += srcDate.substring(dd + 4, dd + 5);
                // Mes
                dateFormat += srcDate.substring(mm + 2, mm + 4);
            } 
            else {
                dateFormat = srcDate.substring(mm, mm + 2) + srcDate.substring(mm + 2, mm + 3) + srcDate.substring(dd, dd + 2) + srcDate.substring(dd + 2, dd + 3) + srcDate.substring(y, y + 4);
            }

            // Extrae cada elemento de fecha y los convierte en enteros
            var dia;
            var mes;
            var anho;
 
            // Casos para tipo de fecha: "yy/dd/mm"
            if(format === 'yy/dd/mm') { 
 
                anho = dateFormat.substring(0, 4);
                dia = dateFormat.substring(5, 7);
                mes = dateFormat.substring(8, 10);                        
            }
            else {
 
                mes = dateFormat.substring(0, 2);
                dia = dateFormat.substring(3, 5);
                anho = dateFormat.substring(6, 10);
            }

            return anho + '-' + mes + '-' + dia;
        }

        /**
         * Converts a birth date (yyyy-MM-dd) to the default defined format date
         * @param {string} date
         * @returns {string} date formatted
         */
        function toDefaultDate(srcDate) {
            if(srcDate && srcDate.length>9){

        
                var mes = srcDate.substring(5, 7);
                var dia = srcDate.substring(8, 10);
                var anho = srcDate.substring(0, 4);

                return format.replace('dd', dia).replace('mm', mes).replace('yy', anho);
            }
            else{
                return '';
            }
        }

        /**
         * Test if date is after today
         * @param {string} date
         * @returns {boolean}
         */
        function isDateAfterToday(testDate) {
            if (this.isValidDate(testDate)) {
                var dateFormat;
                if (inditex.iStoreJSON.countryCode === 'CN') {
                    dateFormat = testDate.substring(mm + 2, mm + 4) + testDate.substring(mm + 4, mm + 5) + testDate.substring(dd + 2, dd + 4) + testDate.substring(y + 4, y + 5) + testDate.substring(y, y + 4);
                } else {
                    dateFormat = testDate.substring(mm, mm + 2) + testDate.substring(mm + 2, mm + 3) + testDate.substring(dd, dd + 2) + testDate.substring(dd + 2, dd + 3) + testDate.substring(y, y + 4);
                }

                return new Date(dateFormat) > new Date();

            } else {
                // is invalid date
                return false;
            }
        }

        /**
         * Test if date is after yesterday
         * @param {string} date
         * @returns {boolean}
         */
        function isDateAfterYesterday(testDate) {
            if (this.isValidDate(testDate)) {
                var dateFormat;
                if (inditex.iStoreJSON.countryCode === 'CN') {
                    dateFormat = testDate.substring(mm + 2, mm + 4) + testDate.substring(mm + 4, mm + 5) + testDate.substring(dd + 2, dd + 4) + testDate.substring(y + 4, y + 5) + testDate.substring(y, y + 4);
                } else {
                    dateFormat = testDate.substring(mm, mm + 2) + testDate.substring(mm + 2, mm + 3) + testDate.substring(dd, dd + 2) + testDate.substring(dd + 2, dd + 3) + testDate.substring(y, y + 4);
                }

                var yesterday = new Date();
                yesterday.setDate(yesterday.getDate() - 1);

                return new Date(dateFormat) > yesterday;

            } else {
                // is invalid date
                return false;
            }
        }

        /**
         * Test if hour is valid (format + hour)
         * @param {string} hour
         * @returns {boolean}
         */
        function isValidHour(testHour) {
            var expr = '^([0-1][0-9]|[2][0-3])\:([0-5][0-9])$';
            var reg = new RegExp(expr);
            return reg.test(testHour);
        }
        /**
         * Test if hour is valid (format + hour)
         * @param {string} date
         * @param {int} years
         * @returns {boolean}
         */
        function isValidAge(birthDate, minAge) {
            var testDate = birthDate;
            if (birthDate.indexOf('/') < 1) {
                testDate = birthDate.substring(0, 2) + '/' + birthDate.substring(2, 4) + '/' + birthDate.substring(4, 8);
            }

            var today = new Date();
            var sliceBirth = testDate.split('/');
            var getBirth = new Date(sliceBirth[2], sliceBirth[1] - 1, sliceBirth[0]);
            if (getDateFormat() === 'M') {
                getBirth = new Date(sliceBirth[2], sliceBirth[0] - 1, sliceBirth[1]);
            }
            if (today.getTime() - getBirth.getTime() > minAge * 3.154e+10) {
                return true;
            } else {
                return false;
            }

            function getDateFormat() {
                var format = getFormatDate();
                return format.replace('yy', 'yyyy').toUpperCase().charAt(0);
            }

        }


        /**
         * Test if hour is valid (format + hour)
         * @param {string} datetime
         * @param {int} minutes
         * @returns {boolean}
         */
        function isWithinDatetime(testDate, minutes) {
            function getDateFormat() {
                var format = getFormatDate();
                return format.replace('yy', 'yyyy').toUpperCase();
            }
            var today = moment();
            var inputDate = moment(testDate, getDateFormat() + ' HH:mm');
            if (inputDate.isValid()) {
                if (inputDate.diff(today, 'm') < minutes) {
                    return false;
                } else {
                    return true;
                }
            }
        }

        function getCalendarFormat(date) {
                if(!date){
                    return undefined;
                }
                var dateFormat = 'DD/MM/YY';

                if (CountryService.is(DUTTI_CONS.stores.DuttiUS)) {
                    dateFormat = 'MM/DD/YY';
                }

                if (CountryService.is(DUTTI_CONS.stores.DuttiCN) ||
                    CountryService.is(DUTTI_CONS.stores.DuttiKR) ||
                    CountryService.is(DUTTI_CONS.stores.DuttiLT) ||
                    CountryService.is(DUTTI_CONS.stores.DuttiHU) ||
                    CountryService.is(DUTTI_CONS.stores.DuttiLU)
                ) {
                    dateFormat = 'YY/MM/DD';
                }


                moment.updateLocale('en', {
                    weekdays: [
                        ItxTranslateSvc.translateCms('legacy.sunday') || dateTranslations.sunday,
                        ItxTranslateSvc.translateCms('legacy.monday') || dateTranslations.monday,
                        ItxTranslateSvc.translateCms('legacy.tuesday') || dateTranslations.tuesday,
                        ItxTranslateSvc.translateCms('legacy.wednesday') || dateTranslations.wednesday,
                        ItxTranslateSvc.translateCms('legacy.thursday') || dateTranslations.thursday,
                        ItxTranslateSvc.translateCms('legacy.friday') || dateTranslations.friday,
                        ItxTranslateSvc.translateCms('legacy.saturday') || dateTranslations.saturday
                    ]
                });

                var newDate = moment(date).calendar(null, {
                    sameDay: '[' + (ItxTranslateSvc.translateCms('legacy.today') || dateTranslations.today) + ']' + ', ' + dateFormat,
                    nextDay: '[' + (ItxTranslateSvc.translateCms('legacy.tomorrow') || dateTranslations.tomorrow)+ ']' + ', ' + dateFormat,
                    nextWeek: 'dddd' + ', ' + dateFormat,
                    lastDay: 'dddd' + ', ' + dateFormat,
                    lastWeek: 'dddd' + ', ' + dateFormat,
                    sameElse: 'dddd' + ', ' + dateFormat
                })

                return newDate.replace(/\//g , ".");
        }

        function loadDateTranslations() {
            var date = {
                today: ItxTranslateSvc.translateCms('legacy.today'),
                tomorrow: ItxTranslateSvc.translateCms('legacy.tomorrow'),
                sunday: ItxTranslateSvc.translateCms('legacy.sunday'),
                monday: ItxTranslateSvc.translateCms('legacy.monday'),
                tuesday: ItxTranslateSvc.translateCms('legacy.tuesday'),
                wednesday: ItxTranslateSvc.translateCms('legacy.wednesday'),
                thursday: ItxTranslateSvc.translateCms('legacy.thursday'),
                friday: ItxTranslateSvc.translateCms('legacy.friday'),
                saturday: ItxTranslateSvc.translateCms('legacy.saturday')
            };
            dateTranslations = date;
        }
    }

})();